module.exports = __webpack_public_path__ + "static/media/phone_4.cb57a89e.png";